import { supabase } from '../lib/supabase';

export const profileService = {
  async getProfile(userId) {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('id', userId)?.single();

    if (error) throw error;

    return {
      id: data?.id,
      email: data?.email,
      fullName: data?.full_name,
      avatarUrl: data?.avatar_url,
      role: data?.role,
      workspaceName: data?.workspace_name,
      timezone: data?.timezone,
      emailNotifications: data?.email_notifications,
      systemNotifications: data?.system_notifications,
      twoFactorEnabled: data?.two_factor_enabled,
      phoneNumber: data?.phone_number,
      stripeCustomerId: data?.stripe_customer_id,
      totalOrders: data?.total_orders,
      totalSpent: data?.total_spent,
      createdAt: data?.created_at,
      updatedAt: data?.updated_at
    };
  },

  async updateProfile(userId, updates) {
    const dbUpdates = {};
    
    if (updates?.fullName !== undefined) dbUpdates.full_name = updates?.fullName;
    if (updates?.avatarUrl !== undefined) dbUpdates.avatar_url = updates?.avatarUrl;
    if (updates?.workspaceName !== undefined) dbUpdates.workspace_name = updates?.workspaceName;
    if (updates?.timezone !== undefined) dbUpdates.timezone = updates?.timezone;
    if (updates?.phoneNumber !== undefined) dbUpdates.phone_number = updates?.phoneNumber;
    if (updates?.emailNotifications !== undefined) dbUpdates.email_notifications = updates?.emailNotifications;
    if (updates?.systemNotifications !== undefined) dbUpdates.system_notifications = updates?.systemNotifications;

    const { data, error } = await supabase?.from('user_profiles')?.update(dbUpdates)?.eq('id', userId)?.select()?.single();

    if (error) throw error;

    return {
      id: data?.id,
      email: data?.email,
      fullName: data?.full_name,
      avatarUrl: data?.avatar_url,
      role: data?.role,
      workspaceName: data?.workspace_name,
      timezone: data?.timezone,
      emailNotifications: data?.email_notifications,
      systemNotifications: data?.system_notifications,
      twoFactorEnabled: data?.two_factor_enabled,
      phoneNumber: data?.phone_number,
      stripeCustomerId: data?.stripe_customer_id,
      totalOrders: data?.total_orders,
      totalSpent: data?.total_spent,
      createdAt: data?.created_at,
      updatedAt: data?.updated_at
    };
  },

  async updateAvatar(userId, avatarFile) {
    const fileExt = avatarFile?.name?.split('.')?.pop();
    const fileName = `${userId}-${Math.random()}.${fileExt}`;
    const filePath = `${fileName}`;

    const { error: uploadError } = await supabase?.storage?.from('avatars')?.upload(filePath, avatarFile);

    if (uploadError) throw uploadError;

    const { data: { publicUrl } } = supabase?.storage?.from('avatars')?.getPublicUrl(filePath);

    const { data, error } = await supabase?.from('user_profiles')?.update({ avatar_url: publicUrl })?.eq('id', userId)?.select()?.single();

    if (error) throw error;

    return publicUrl;
  }
};